/* iVUE build-out P1, 2026-10-09. Mini-cart drawer (sections/ivue26-shop-drawer.liquid).
   Opens from the header cart icon and after window.ivue26Cart.add (defined by the 5 pages' chrome JS and kit-base JS), which it wraps
   rather than editing those bundles. Re-renders through the Section Rendering API. Named ivue26-kit-shop-drawer.js so it stays out of
   the 5 pages' purge corpus (D8). With JS off every link and form still goes to /cart. */
(() => {
  const SEL = '[data-sd]';
  let trigger = null;
  const root = () => document.querySelector(SEL);
  const onCartPage = () => /^\/cart\/?$/.test(location.pathname);

  const setCount = (n) => {
    if (window.ivue26Cart && window.ivue26Cart.setCount) { window.ivue26Cart.setCount(n); return; }
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n; el.dataset.n = n; });
  };

  async function refresh() {
    const el = root();
    if (!el) return;
    const id = el.dataset.sectionId;
    const res = await fetch(`${location.pathname}?sections=${encodeURIComponent(id)}&_sd=${Date.now()}`, { cache: 'no-store' }); // no Accept: json, or a product URL answers with the product JSON
    if (!res.ok) throw new Error('drawer ' + res.status);
    const html = (await res.json())[id];
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(SEL);
    if (!fresh) return;
    const msg = el.querySelector('[data-sd-msg]');
    const keep = msg && msg.classList.contains('is-on') ? msg.textContent : '';
    el.innerHTML = fresh.innerHTML;
    if (keep) say(keep);
  }

  function say(text) {
    const m = root()?.querySelector('[data-sd-msg]');
    if (!m) return;
    m.textContent = text;
    m.classList.toggle('is-on', !!text);
  }

  const focusables = (el) => [...el.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')].filter((f) => f.offsetParent !== null);

  function open(msg) {
    const el = root();
    if (!el) return;
    say(msg || '');
    if (!el.classList.contains('is-open')) {
      trigger = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sd-lock');
      document.querySelector('main')?.setAttribute('inert', '');
      el.querySelector('.sd__panel')?.focus();
    }
  }

  function close() {
    const el = root();
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sd-lock');
    document.querySelector('main')?.removeAttribute('inert');
    say('');
    if (trigger && trigger.focus) trigger.focus();
    trigger = null;
  }

  // wrap the shared add so every add on the site ends in the drawer
  function hook() {
    const c = window.ivue26Cart;
    if (!c || !c.add || c.add.sdWrapped) return !!(c && c.add && c.add.sdWrapped);
    const orig = c.add;
    const wrapped = async (items) => {
      const r = await orig(items);
      if (onCartPage()) return r;
      const pre = Array.isArray(r && r.items) && r.items.some((i) => i.selling_plan_allocation || (i.properties && i.properties._preorder === 'true'));
      const el = root();
      try { await refresh(); } catch (e) { /* the drawer shows the server-rendered cart */ }
      open(pre ? el?.dataset.addedPre : el?.dataset.added);
      return r;
    };
    wrapped.sdWrapped = true;
    c.add = wrapped;
    return true;
  }
  if (!hook()) {
    let tries = 0;
    const t = setInterval(() => { if (hook() || ++tries > 40) clearInterval(t); }, 150);
  }

  document.addEventListener('click', async (e) => {
    const icon = e.target.closest('header a[href="/cart"], .tn a[href="/cart"], .mn a[href="/cart"]');
    if (icon && !onCartPage() && root()) {
      e.preventDefault();
      open('');
      refresh().catch(() => {});
      return;
    }
    if (e.target.closest('[data-sd-close]')) { close(); return; }
    const q = e.target.closest('.sd [data-sd-q]');
    if (!q) return;
    e.preventDefault();
    const el = root();
    el.classList.add('is-busy');
    try {
      const line = Number(q.closest('[data-line]').dataset.line);
      const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: Number(q.dataset.sdQ) }) });
      if (!res.ok) throw new Error('change ' + res.status);
      const cart = await res.json();
      setCount(cart.item_count);
      say('');
      await refresh();
      root()?.querySelector('.sd__x')?.focus();
    } catch (err) {
      location.href = q.href;
    } finally {
      root()?.classList.remove('is-busy');
    }
  });

  document.addEventListener('keydown', (e) => {
    const el = root();
    if (!el || !el.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables(el.querySelector('.sd__panel'));
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === el.querySelector('.sd__panel'))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  addEventListener('pageshow', (e) => { if (e.persisted) refresh().catch(() => {}); });
  window.ivue26Drawer = { open, close, refresh };
})();
